(() => {
  const nonColourTokens = /^(usb|type[- ]?c|au|eu|us|uk|color box|colour box|no box|with box)$/i;

  const colourLabel = (title = '') => {
    const parts = title.split('/').map((part) => part.trim()).filter(Boolean);
    const candidate = parts.find((part) => !nonColourTokens.test(part));
    return candidate || parts[0] || title;
  };

  const setup = (form) => {
    if (!form || form.dataset.bundleColoursReady === 'true') return;
    form.dataset.bundleColoursReady = 'true';

    const radios = [...form.querySelectorAll('input[name="bundle_quantity"]')];
    const slots = [...form.querySelectorAll('[data-vt-colour-slot]')];
    const selects = [...form.querySelectorAll('[data-bundle-colour-select]')];

    selects.forEach((select) => {
      [...select.options].forEach((option) => {
        option.textContent = colourLabel(option.textContent.replace(/— Sold out/i, '').trim());
      });
    });

    const sync = () => {
      const quantity = Number(radios.find((radio) => radio.checked)?.value || 1);
      slots.forEach((slot, index) => { slot.hidden = index >= quantity; });
      radios.forEach((radio) => radio.closest('.vt-bundle-option')?.classList.toggle('is-selected', radio.checked));
    };

    radios.forEach((radio) => radio.addEventListener('change', sync));
    sync();
  };

  const setupAll = (root = document) => root.querySelectorAll?.('[data-vt-bundle-form]').forEach(setup);
  document.addEventListener('DOMContentLoaded', () => setupAll());
  document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
  setupAll();

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest?.('[data-vt-bundle-form]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();

    const selectedBundle = form.querySelector('input[name="bundle_quantity"]:checked');
    const quantity = Number(selectedBundle?.value || 1);
    const code = selectedBundle?.dataset.code || '';
    const visibleSelects = [...form.querySelectorAll('[data-bundle-colour-select]')].slice(0, quantity);
    const defaultVariant = form.querySelector('input[name="id"]')?.value;

    const selectedIds = visibleSelects.length
      ? visibleSelects.map((select) => select.value)
      : defaultVariant ? Array.from({ length: quantity }, () => defaultVariant) : [];

    const counts = new Map();
    selectedIds.forEach((id) => counts.set(id, (counts.get(id) || 0) + 1));
    const items = [...counts].map(([id, itemQuantity]) => ({ id: Number(id), quantity: itemQuantity }));
    if (!items.length) return;

    const button = form.querySelector('.vt-add');
    const note = form.querySelector('.vt-bundle-note');
    const originalText = button?.textContent || 'ADD BUNDLE TO CART';
    if (button) { button.disabled = true; button.textContent = 'ADDING…'; }
    if (note) note.textContent = 'Adding your selected colours…';

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not add this bundle');
      if (button) button.textContent = 'ADDED ✓';
      const cartPath = window.routes?.cart_url || `${root}cart`;
      window.location.href = code
        ? `${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(cartPath)}`
        : cartPath;
    } catch (error) {
      if (button) { button.disabled = false; button.textContent = originalText; }
      if (note) note.textContent = error.message || 'Could not add this bundle. Please try again.';
    }
  }, true);
})();
